import { render, staticRenderFns } from "./invoice-modal.vue?vue&type=template&id=4f898372"
import script from "./invoice-modal.vue?vue&type=script&lang=js"
export * from "./invoice-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports